import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../../../../init-store';

type FullscreenState = {
    isFullscreen: boolean;
    fullscreenType: FullscreenType | null;
};

export const enum FullscreenType {
    Browser = 'browser',
    Windowed = 'windowed',
}

const initialState: FullscreenState = {
    isFullscreen: false,
    fullscreenType: null,
};

const fullscreenSlice = createSlice({
    name: 'fullscreen',
    initialState: initialState,
    reducers: {
        setStoreIsFullscreen(state, action: PayloadAction<boolean>) {
            state.isFullscreen = action.payload;
            state.fullscreenType = action.payload ? FullscreenType.Browser : null;
        },
        setStoreWindowedFullscreen(state, action: PayloadAction<boolean>) {
            state.isFullscreen = action.payload;
            state.fullscreenType = action.payload ? FullscreenType.Windowed : null;
        },
        resetFullscreen() {
            return initialState;
        },
    },
});

export const setIsFullscreenAction = createAction<boolean>('conference/fullscreen/isFullscreen');
export const setBrowserFullscreenAction = createAction<boolean>('conference/fullscreen/browserFullscreen');
export const { setStoreIsFullscreen, setStoreWindowedFullscreen, resetFullscreen } = fullscreenSlice.actions;
export const selectIsFullscreen = (state: RootState) => state.call.fullscreen.isFullscreen;
export const selectFullscreenType = (state: RootState) => state.call.fullscreen.fullscreenType;
export const selectIsWindowedFullscreen = (state: RootState) =>
    state.call.fullscreen.isFullscreen && state.call.fullscreen.fullscreenType === FullscreenType.Windowed;
export const fullscreenReducer = fullscreenSlice.reducer;
